import { lazy, Suspense } from "react"
import type { RouteObject } from "react-router-dom"
import { useRoutes } from "react-router-dom"
import Layout from "@/components/Layout"
import Home from "@/pages/Home"

const FranchiseFinancing = lazy(() => import("@/pages/FranchiseFinancing"))
const SBALoans = lazy(() => import("@/pages/SBALoans"))
const BarFinancing = lazy(() => import("@/pages/BarFinancing"))
const StartupGuide = lazy(() => import("@/pages/StartupGuide"))

function PageLoader() {
  return (
    <div className="min-h-screen bg-[#0A1628] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-emerald-500/30 border-t-emerald-500 rounded-full animate-spin" />
    </div>
  )
}

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      {
        path: "/franchise-financing",
        element: (
          <Suspense fallback={<PageLoader />}>
            <FranchiseFinancing />
          </Suspense>
        ),
      },
      {
        path: "/sba-loans",
        element: (
          <Suspense fallback={<PageLoader />}>
            <SBALoans />
          </Suspense>
        ),
      },
      {
        path: "/bar-financing",
        element: (
          <Suspense fallback={<PageLoader />}>
            <BarFinancing />
          </Suspense>
        ),
      },
      {
        path: "/startup-guide",
        element: (
          <Suspense fallback={<PageLoader />}>
            <StartupGuide />
          </Suspense>
        ),
      },
    ],
  },
]

function App() {
  return useRoutes(routes)
}

export default App
